module.exports = __webpack_public_path__ + "img/1304057366.28b7eec8.jpg";